import invoiceTypes from './invoiceTypes'
import moment from 'moment'

export const initialState = {
  filters: {
    LastModifiedDateFrom: moment().subtract(1, 'days').format('YYYY-MM-DD'),
    UploadedDateFrom: '',
    UploadedDateTo: '',
    InvoiceStatusID: ''
  },
  invoices: [],
  loadPage: false,
  error: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case invoiceTypes.GET_INVOICES:
      return {
        ...state,
        loadPage: true,
        error: ''
      }

    case invoiceTypes.GET_INVOICES_SUCCESS: {
      return {
        ...state,
        invoices: payload.filter(invoice => invoice.InvoiceStatusId !== 3),
        loadPage: false,
        error: ''
      }
    }

    case invoiceTypes.GET_INVOICES_FAILURE: {
      return {
        ...state,
        loadPage: false,
        error: payload,
        invoices: []
      }
    }

    case invoiceTypes.CLEAR_INVOICES: {
      return {
        ...state,
        loadPage: true
      }
    }

    case invoiceTypes.SET_FILTERS : {
      const filters = (!payload) ? { ...initialState.filters } : {
        ...state.filters,
        ...payload,
        offset: 0
      }

      return {
        ...state,
        filters,
        loadPage: true
      }
    }

    default: return state
  }
}
